import { LoggedUserService } from '@core/service/logged-user.service';
import { FlamingoAuthService } from '@flamingo/service/flamingo-auth.service';
import { EMPTY, Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

export function initializeApp(
  authService: FlamingoAuthService,
  userService: LoggedUserService,
): () => Observable<any> {
  return () => {
    return userService.fetch()
      .pipe(
        tap(_ => console.log('Startup App')),
        catchError(_ => {
          authService.logout();
          return EMPTY;
        }),
      );
  };
}
